<template>
    <div class="login-admin">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-7 col-lg-5">
                    <div class="wrap">
                        <div class="img">
                            <img :src="$urlImage('/images/bg-login.jpg')"/>
                        </div>
                        <div class="login-wrap p-4 p-md-5 position-relative">
                            <h3 class="text-center">Đăng nhập</h3>
                            <div class="form-login mt-4">
                                <div class="text-field">
                                    <label for="username">Tên đăng nhập</label>
                                    <input type="text" id="username" v-model="form.username" @keyup.enter="login()" placeholder="Nhập tên đăng nhập" />
                                    <div class="text-error ms-1" v-if="!form.username">{{ err.username }}</div>
                                </div>
                                <div class="text-field mt-4">
                                    <label for="password">Mật khẩu</label>
                                    <input type="password" id="password" v-model="form.password" @keyup.enter="login()" placeholder="Nhập mật khẩu" />
                                    <div class="text-error ms-1" v-if="!form.password">{{ err.password }}</div>
                                </div>
                            </div>
                            <div class="button-login text-center">
                                <button class="btn bg-primary w-100 text-white" @click="login()">Đăng nhập</button>
                            </div>
                            <div class="loading-admin position-absolute" v-if="loading">
                                <div class="fade-loading"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                username: '',
                password: '',
            },
            err: {
                username: '',
                password: '',
            },
            loading: false,
        }
    },
    methods: {
        async login() {
            this.loading = true;
            await apiPost('/login', this.form).then(res => {
                this.$toast.success(res.message, {
                    timeout: 3000,
                });
                localStorage.setItem('token', res.access_token);
                this.$router.push({
                    name: 'layout',
                });
            }).catch(err => {
                if(err.status == 400) {
                    this.err.username = err.data.username[0];
                    this.err.password = err.data.password[0];
                }
                if(err.status == 401) {
                    this.$toast.error(err.data.message, {
                        timeout: 3000,
                    });
                }
            });
            this.loading = false;
        },
    }
}
</script>

<style lang="scss">
.login-admin {
    padding: 10rem 0;
    background: #f8f9fd;
    height: 100vh;
    overflow: hidden;
    .wrap {
        width: 100%;
        overflow: hidden;
        background: #fff;
        border-radius: 5px;
        box-shadow: 0 10px 34px -15px rgb(0 0 0 / 24%);
        .img {
            height: 200px;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .login-wrap {
            .form-login {
                .text-field {
                    position: relative;
                }
                .text-field label {
                    display: inline-block;
                    font-weight: 600;
                    position: absolute;
                    top: 0;
                    left: 10px;
                    background-color: #fff;
                    padding: 1px 5px;
                    font-size: 12px;
                    transform: translateY(-50%);
                    color: #0d6efd;
                }
                .text-field input {
                    padding: 15px;
                    display: block;
                    width: 100%;
                    font-size: 14px;
                    border: 1px solid #0d6efd;
                    border-radius: 4px;
                    background-color: transparent;
                    &:focus {
                        outline: transparent !important;
                        box-shadow: 0 4px 15px 0 rgba(30,30,30,.12);
                    }
                }
            }
            .button-login {
                margin-top: 14px;
                button {
                    padding: 10px 0;
                    &:hover {
                        box-shadow: 0 10px 20px -10px rgba(13, 110, 253,.7);
                    }
                }
            }
        }
    }
}
</style>
